import { PHONE, CHAT, STATUSES, STRING_REPLACE } from '../enums';
import getPublicHolidayName from './getPublicHolidayName';
import setBold from './setBold';
import setHours from './setHours';
import getOpeningHours from './getOpeningHours';

var getText = function getText(_ref) {
  var strType = _ref.strType,
      strStatus = _ref.strStatus,
      todaysopeninghours = _ref.todaysopeninghours,
      objContactData = _ref.objContactData,
      bSubscriptionpage = _ref.bSubscriptionpage,
      dToday = _ref.dToday,
      widgetData = _ref.widgetData;
  var OPEN = STATUSES.OPEN,
      OPENSOON = STATUSES.OPENSOON,
      CHATBOT = STATUSES.CHATBOT;
  var HOLIDAYNAME = STRING_REPLACE.HOLIDAYNAME,
      PHONENR = STRING_REPLACE.PHONENR;
  var data = {};
  var strPublicHolidayName = getPublicHolidayName({
    dToday: dToday,
    widgetData: widgetData
  });
  var strTelnr = objContactData.telnr;
  var strEditTxt = '';
  var strExtraInfoTxt = '';

  if (bSubscriptionpage) {
    strTelnr = objContactData.subscriptiontelnr;
  }

  if (strType === PHONE || strType === CHAT) {
    switch (strStatus) {
      case OPEN:
        strEditTxt = setBold(setHours({
          strText: objContactData.opentext,
          arrHours: todaysopeninghours
        }));
        break;

      case OPENSOON:
        strEditTxt = setBold(setHours({
          strText: objContactData.closedtext,
          arrHours: todaysopeninghours
        }));
        break;

      case CHATBOT:
        strEditTxt = getOpeningHours({
          jsonOpeningHours: objContactData.openinghours.hours
        });
        break;

      default:
        strEditTxt = getOpeningHours({
          jsonOpeningHours: objContactData.openinghours.hours
        });
        break;
    }

    if (strPublicHolidayName) {
      var strExtraInfoHoliday = widgetData.jsonSettings.settings.publicholidays.extrainfo;

      if (strExtraInfoHoliday) {
        strExtraInfoTxt = "<span>" + setBold(strExtraInfoHoliday.replace(HOLIDAYNAME, strPublicHolidayName)) + "</span>";
      }
    }
  }

  if (objContactData.extrainfo && !strPublicHolidayName) {
    strExtraInfoTxt = "<span>" + setBold(objContactData.extrainfo) + "</span>";
  }

  data.maintext = setBold(objContactData.maintext.replace(PHONENR, strTelnr));

  if (strEditTxt) {
    data.edittext = strEditTxt + "<br />" + strExtraInfoTxt;
  } else {
    data.edittext = strExtraInfoTxt;
  }

  return data;
};

export default getText;